import { createReducer } from "@reduxjs/toolkit";
import { IItem } from "Model/Storage/IItem";
import {
  projectsStagingManageDialog,
  projectsStagingManageRemoveSuccess,
  projectsStagingManageStart,
  projectsStagingManageSuccess
} from "Store/Actions";
import { isEmpty } from "Utils/Object";
import { isNullOrWhiteSpace } from "Utils/String";

export const ignoredValues = createReducer<IItem>({} as IItem, {
  [projectsStagingManageSuccess.type]: (_, { payload }) => {
    if (isEmpty(payload)) {
      return {};
    }

    return payload;
  },
  [projectsStagingManageRemoveSuccess.type]: (state, { payload: property }) => {
    if (isNullOrWhiteSpace(property)) {
      return state;
    }

    if (isEmpty(state)) {
      return state;
    }

    return Object.fromEntries(Object.entries(state).filter(([prop]) => prop !== property));
  }
});

export const showIgnoredValuesDialog = createReducer<boolean>(false, {
  [projectsStagingManageDialog.type]: (_, { payload }) => payload,
  [projectsStagingManageStart.type]: () => true
});
